// extracted by mini-css-extract-plugin
module.exports = {"signIn__signUp__btn":"Button_signIn__signUp__btn__1fyNF","LogoutBtn":"Button_LogoutBtn__1b1Tw"};